import _get from 'lodash/get';
import _has from 'lodash/has';
import _head from 'lodash/head';
import _orderBy from 'lodash/orderBy';
import _remove from 'lodash/remove';
import useProfileCommonStore from '../use-profile-common-store';

import { useProfileSectorDiversification } from '../../../hooks/api';

const useSectorDiversification = () => {

  const { apiConfigBase } = useProfileCommonStore();

  const { isLoaded, data = {} } = useProfileSectorDiversification(apiConfigBase);

  let sectors = [];

  if (data.sectors) sectors = data.sectors;

  const sortedSectors = _orderBy(sectors, ['sectorPercent'], ['desc']);

  //remove short term investment sector
  const shortTermInvestmentsSector = _remove(sortedSectors, sector => {
    return sector.sector === 'Short-Term Investments, Other Assets & Liabilities, Net';
  });
  //add it to the end of the list
  if (shortTermInvestmentsSector.length) sortedSectors.push(shortTermInvestmentsSector[0]);

  const asOfDate = data.asOfDate || _get(_head(sectors), 'quarterEndDate');

  return {
    asOfDate: asOfDate || '',
    sectors: sortedSectors && sortedSectors.length ? sortedSectors : [{ sector: '--', sectorPercent: 0 }],
    renderSectorDiversification: isLoaded ? data?.sectors?.some(item => _has(item, 'sectorPercent')) : true
  };
};

export default useSectorDiversification;
